import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { faqData } from '../../data/Data';
import { Helmet } from 'react-helmet';

const Faq = () => {
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [search, setSearch] = useState('');

    const toggleAccordion = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const filteredFaqs = faqData.filter(item =>
        item.question.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            <Helmet>
                <title>FAQs | PG Overseas Services | Migration & Business Support Queries</title>
                <meta
                    name="description"
                    content="Find answers to common questions about PG Overseas Services' international consulting, migration support, real estate, and global expansion services."
                />
                <meta
                    name="keywords"
                    content="PG Overseas FAQ, migration questions, global business consulting help, relocation support answers, NRI services India, business visa queries"
                />
            </Helmet>

            <section className="py-16 bg-gray-100 font-basefont mt-10">
                <div className="max-w-3xl mx-auto px-6 lg:px-8">
                    <h1 className="text-4xl font-bold text-center text-basecolor mb-8">
                        Frequently Asked Questions
                    </h1>

                    <div className="mb-8">
                        <input
                            type="text"
                            placeholder="Search questions..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="w-full px-4 py-3 rounded-md  "
                        />
                    </div>

                    <div className="space-y-4">
                        {filteredFaqs.length > 0 ? (
                            filteredFaqs.map((item, index) => (
                                <div key={index} className="bg-white rounded-md shadow-md overflow-hidden">
                                    <button
                                        className="w-full text-left py-4 px-6 font-semibold flex justify-between items-center"
                                        onClick={() => toggleAccordion(index)}
                                        aria-expanded={expandedIndex === index}
                                        aria-controls={`faq-content-${index}`}
                                    >
                                        {item.question}
                                        {expandedIndex === index ? (
                                            <FaChevronUp className="text-gray-500" />
                                        ) : (
                                            <FaChevronDown className="text-gray-500" />
                                        )}
                                    </button>
                                    <div
                                        id={`faq-content-${index}`}
                                        className={`px-6 py-4 text-gray-700 transition-all duration-300 ease-in-out ${expandedIndex === index ? 'block' : 'hidden'
                                            }`}
                                    >
                                        {item.answer}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-gray-600">No matching questions found.</p>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Faq;
